import { ReactElement, useId } from 'react';
import { DecimalField, useForm, useOnFieldChange } from '@ff-it/form';
import { required } from 'utilities';
import { expenseBackground, incomeBackground } from '../columns/style.css';
import { Box, Stack, Switch } from '@ff-it/ui';

function ToggleSplit({ enabled }: { enabled: boolean }): ReactElement {
  const form = useForm();
  const id = useId();
  const onToggle = () => {
    form.batch(() => {
      const { alt_prices, quantity, total } = form.getState().values;

      // disable
      if (alt_prices) {
        form.change('alt_prices', false);
        form.change('alt_quantity', null);
        form.change('alt_total', null);
      } else {
        form.change('alt_prices', true);
        form.change('alt_quantity', quantity);
        form.change('alt_total', total);
      }
    });
  };

  return (
    <Box mt="2" display="flex" alignItems="center" gap="2" px="2">
      <Switch name="alt_prices" size="sm" id={id} checked={enabled} onChange={onToggle} />
      <label htmlFor={id}>Split prices</label>
    </Box>
  );
}

export function FormFields(): ReactElement {
  const split = useOnFieldChange(
    'alt_prices',
    (next, prev) => {
      // just enabled alt prices
      if (!prev && next) {
        const alt_quantity = document.querySelector<HTMLInputElement>('input[name="alt_quantity"]');
        if (alt_quantity && !alt_quantity.value) {
          alt_quantity.focus();
        } else {
          const alt_total = document.querySelector<HTMLInputElement>('input[name="alt_total"]');
          alt_total?.focus();
        }
      }
    },
    false,
  );

  return (
    <Stack direction="vertical" space="0.5">
      {split && (
        <Stack className={incomeBackground} direction="horizontal" p="3">
          <DecimalField
            name="alt_quantity"
            required
            validate={required}
            label="Client quantity"
            precision={4}
            size="sm"
            className="mb-0"
          />
          <DecimalField
            name="alt_total"
            required
            validate={required}
            label="Client total"
            precision={18}
            size="sm"
            className="mb-0"
          />
        </Stack>
      )}
      <Stack className={split ? expenseBackground : undefined} direction="horizontal" p="3">
        <DecimalField
          name="quantity"
          required
          validate={required}
          label="Quantity"
          precision={4}
          size="sm"
          className="mb-0"
        />
        <DecimalField
          name="total"
          required
          validate={required}
          label="Total"
          precision={18}
          size="sm"
          className="mb-0"
        />
      </Stack>
      <ToggleSplit enabled={split} />
    </Stack>
  );
}
